import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import {
    PAYMENT_CONDITIONS_FAILED,
    PAYMENT_CONDITIONS_RECEIVED,
    PAYMENT_CONDITIONS_REQUEST,
    PAYMENT_CONDITION_CREATE,
    PAYMENT_CONDITION_CREATED,
    PAYMENT_CONDITION_DELETE,
    PAYMENT_CONDITION_UPDATE,
} from './payment-terms-actions';
import { PaymentTerm } from '../../../../../common/models/payment-term';

export interface PaymentTermsReducerState {
    paymentTerms: PaginatedResponse<PaymentTerm>;
    requesting: boolean;
}

export const initialPaymentTermsReducerState: PaymentTermsReducerState = {
    paymentTerms: { items: [], limit: 0, page: 0, total: 0 },
    requesting: false,
};

export const paymentTermsReducer = (
    state: PaymentTermsReducerState = initialPaymentTermsReducerState,
    action: AnyAction
): PaymentTermsReducerState => {
    const { type } = action;

    switch (type) {
        case PAYMENT_CONDITION_CREATE:
        case PAYMENT_CONDITIONS_REQUEST: {
            return {
                ...state,
                requesting: true,
            };
        }

        case PAYMENT_CONDITIONS_RECEIVED: {
            return {
                ...state,
                paymentTerms: action['paymentTerms'],
                requesting: false,
            };
        }

        case PAYMENT_CONDITIONS_FAILED: {
            return {
                ...state,
                requesting: false,
            };
        }

        case PAYMENT_CONDITION_DELETE: {
            return {
                ...state,
                paymentTerms: {
                    ...state.paymentTerms,
                    items: state.paymentTerms.items.filter(
                        (paymentTerms: PaymentTerm) => paymentTerms.id !== action['paymentTermId']
                    ),
                    total: state.paymentTerms.total - 1,
                },
            };
        }

        case PAYMENT_CONDITION_UPDATE: {
            return {
                ...state,
                paymentTerms: {
                    ...state.paymentTerms,
                    items: state.paymentTerms.items.map((paymentTerm: PaymentTerm) =>
                        paymentTerm.id === action['paymentTerm'].id ? action['paymentTerm'] : paymentTerm
                    ),
                },
            };
        }

        case PAYMENT_CONDITION_CREATED: {
            return {
                ...state,
                paymentTerms: {
                    ...state.paymentTerms,
                    items: [action['paymentTerm'], ...state.paymentTerms.items],
                },
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
